import {DataSourceItem} from '../../store/ast/ast.types';
import {RenderDataSource} from '../../store/data/data.types';
import {buildFilter} from './filter';
import {callMaxFunctionWithReturnVal, pageQueryResult} from '../../api/function_service';
import {userStore} from "../../store";
import {getKeyValue} from "../../store/common/localStorageManager";
import {getConfigByInstanceId} from "../../store/common/action";

/**
 * 执行查询（占位函数，需根据实际API实现）
 * @param dataSource 数据源配置
 * @param renderData
 * @param instanceId
 * @returns 查询结果
 */
async function executeQuery(dataSource: DataSourceItem, renderData: RenderDataSource,instanceId:string): Promise<{ items: any[]; total: number }> {
  let data = {
    items: [],
    total: 0,
  };
  let headers = {};
  headers["not-follow-tenant"] = !!dataSource.notFollowTenant;
  let res = null as any;
  let paging = renderData.paging;
  let page = paging.page || 1;
  let size = paging.size || 10;
  const pageId = getConfigByInstanceId(instanceId)._id
  switch (dataSource.type) {
    case 'form':
      res = await pageQueryResult({
        "type": "result",
        "json": {
          "limit": `${(page - 1) * size},${size}`,
          "sort": [],
          "leftJoin": [],
          "where": dataSource.filter || [],
          "from": {
            "domainCode": dataSource.domainCode,
            "formId": dataSource.formId
          },
          "select": "",
          "alias": {}
        }
      },headers);
      if(res.data && res.data.items && res.data.total){
        data = res.data;
      }
      break;
    case 'function':
      console.log("executeQuery --- ",dataSource)
      res = await callMaxFunctionWithReturnVal({
        "uniqueId": dataSource.prop,
        "objectId": pageId,
        "domainCode": dataSource.domainCode,
        "inputData": dataSource.filter,
        "token": userStore.state.token || getKeyValue('token'),
        "paging": {
          "page": page,
          "limit": size
        }
      },headers);
      if(res.data){
        if(res.data[0]){
          data.items = res.data[0].finalResult;
          data.total = res.data[0].total;
        }
      }
  }


  return Promise.resolve(data);
}

/**
 * 解析并获取数据源数据
 * @param dataSource 数据源配置
 * @param renderDataSources
 * @param attrObject
 * @param parameterType
 * @param instanceId
 * @returns RenderDataSource格式的数据
 */
export async function parseDataSource(dataSource: DataSourceItem, renderDataSources: Map<string, RenderDataSource>,attrObject:object, instanceId:string, parameterType: any = undefined): Promise<RenderDataSource> {
  // 核心修复：判断 attrObject 是否为 JSON 字符串，是则自动解析为对象
  let parsedAttrObject = attrObject;
  if (typeof attrObject === 'string') {
    try {
      parsedAttrObject = JSON.parse(attrObject);
    } catch (e) {
      console.warn('解析数据源数据参数 attrObject JSON 解析失败:', attrObject, e);
    }
  }
  // 使用解析后的对象
  if (parameterType) {
    dataSource.filter = { data: parsedAttrObject };
  } else {
    dataSource.filter = buildFilter(_cloneDeep(dataSource), renderDataSources, parsedAttrObject);
  }

  let renderData = renderDataSources.get(dataSource.prop);
  if (!_get(dataSource, ['notInitialize']) || !_get(renderData, ['initDataSource'])) {
    let queryResult = await executeQuery(dataSource, renderData, instanceId);
    const page = Number(_get(renderData, ['paging', 'page'], 1)) || 1;
    const isRoll =  _get(renderData, ['paging', 'append']) === true;
    const nextItems = Array.isArray(queryResult.items) ? queryResult.items : [];
    const prevItems = Array.isArray(renderData.items) ? renderData.items : [];
    // 滚动分页且非首页追加；普通分页或首页覆盖
    if (isRoll && page > 1) {
      renderData.items = [...prevItems, ...nextItems];
    } else {
      renderData.items = nextItems;
    }
    renderData.paging.total = queryResult.total;
  }
  renderData['initDataSource'] = false;
  return renderData;
}
